var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoCompress = function SvgVideoCompress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.667 0a.5.5 0 0 1 .5.5v3.126l3.48-3.48a.5.5 0 1 1 .707.708l-3.48 3.48H12a.5.5 0 0 1 0 1H7.667a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5M1 7.667a.5.5 0 0 1 0-1h4.333a.5.5 0 0 1 .5.5V11.5a.5.5 0 0 1-1 0V8.374l-3.48 3.48a.5.5 0 1 1-.707-.707l3.48-3.48z",
    clipRule: "evenodd"
  })));
};
export default SvgVideoCompress;